// Format a money amount with thousands separators, rounded to the accounting
// book's currency exponent, with an optional currency symbol. Sign is kept
// in front of the symbol (e.g. -$833,333.33).
const formatAmount = (value, exponent = 0, symbol = '') => {
  const num = Number(value)
  if (Number.isNaN(num)) { return `${symbol}0` }

  const fixed = num.toFixed(exponent)
  const negative = fixed.startsWith('-')
  const [intPart, decPart] = fixed.replace('-', '').split('.')
  const withSep = intPart.replace(/\B(?=(\d{3})+(?!\d))/g, ',')
  const dec = decPart ? `.${decPart}` : ''

  return `${negative ? '-' : ''}${symbol}${withSep}${dec}`
}

export default formatAmount
